import React, { PureComponent, Fragment } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
  CartesianGrid,
} from "recharts";

import {
  StandardTooltip,
  CustomizedXAxisTick,
  selectFormat,
} from "./../../Utils/Utils.js";
import { XRayTooltip } from "./../../Utils/XrayUtils.js";

import Heading from "./../../Elements/Heading.js";

import { getXrayTooltipPosition } from "../../../helpers/DOM";

const COLORS = {
  males: "#14c8de",
  females: "#fa7986",
  unknown: "#fcd239",
};

export default class YoutubeDemographics extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      widgetsData: props.data.data,
      widgetsInsights: [],
      width: 0,
      height: 0,
      tooltip: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.node = React.createRef();
    this.divPosition = React.createRef();

    this.updatePosition = this.updatePosition.bind(this);
  }

  updatePosition() {
    // this.closeTooltip();

    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  }

  UNSAFE_componentWillMount() {
    this.updatePosition();
  }

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  closeTooltip = () => {
    this.setState({
      tooltip: { show: false },
    });
  };

  getExportData = () => ({
    data: Object.keys(this.props.data.age).map((key) => ({
      name: key,
      male: selectFormat("percentage", this.props.data.age[key].male / 100),
      female: selectFormat("percentage", this.props.data.age[key].female / 100),
    })),
    opts: {
      type: "other",
    },
  });
  render() {
    const { data } = this.props;

    const ageGraph = Object.keys(data.age).map((key) => ({
      name: key,
      male: data.age[key].male,
      female: data.age[key].female,
      unknown: data.age[key].unknown,
    }));

    return (
      <div ref={this.divPosition}>
        <Heading size={6}>
          This data only represents the top 100 videos.
        </Heading>
        <ResponsiveContainer height={158}>
          <BarChart
            data={ageGraph}
            layout="vertical"
            margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
            onClick={(d) => {
              const extra =
                d.activePayload !== null &&
                d.activePayload.map((k, j) => ({
                  date: d.activeLabel,
                  key: k.dataKey,
                  value: k.value > 0 && k.value,
                  color: k.color,
                }));

              d.extra = extra;
              this.setState({
                tooltip: { ...d, show: true },
              });
            }}
          >
            {!this.state.tooltip.show && (
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(this.props);

                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {payload[0].payload.name}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              {payload.map((item) => (
                                <Fragment key={item.dataKey}>
                                  <div className="standard-tooltip__item">
                                    <span className="standard-tooltip__key">
                                      <span
                                        className="standard-tooltip__icon"
                                        style={{ background: item.color }}
                                      />
                                      <span className="standard-tooltip__value-header">
                                        {item.dataKey}
                                      </span>
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {selectFormat(
                                        "percentage",
                                        item.payload[item.dataKey] / 100
                                      )}
                                    </span>
                                  </div>
                                </Fragment>
                              ))}
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
            )}
            <XAxis
              type="number"
              axisLine={false}
              tickLine={false}
              mirror={false}
              tick={<CustomizedXAxisTick />}
            />
            <YAxis
              type="category"
              axisLine={false}
              tickLine={false}
              mirror={false}
              dataKey="name"
              interval={0}
            />
            <CartesianGrid
              strokeDasharray="3 3"
              horizontal={false}
              stroke={"#FC6D52"}
              strokeOpacity={0.3}
            />

            <defs>
              <linearGradient
                id="colorDemographicBar"
                x1="0"
                y1="0"
                x2="1"
                y2="0"
              >
                <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
              </linearGradient>
            </defs>

            <Bar
              dataKey="male"
              stackId="stack"
              fill={COLORS.males}
              cursor="pointer"
            />
            <Bar
              dataKey="female"
              stackId="stack"
              fill={COLORS.females}
              cursor="pointer"
            />
            <Bar
              dataKey="unknown"
              stackId="stack"
              fill={COLORS.unknown}
              cursor="pointer"
            ></Bar>
          </BarChart>
        </ResponsiveContainer>

        {this.state.tooltip.activeCoordinate ? (
          <div
            className="xray-tooltip-container"
            style={{
              top: this.state.tooltip.activeCoordinate.y + "px",
              left:
                this.state.tooltip.activeCoordinate.x + 220 < this.state.width
                  ? this.state.tooltip.activeCoordinate.x + 15 + "px"
                  : this.state.tooltip.activeCoordinate.x +
                    50 +
                    "px" -
                    getXrayTooltipPosition(
                      this.divPosition.current,
                      this.state.tooltip.activeCoordinate
                    ) +
                    "px",
              opacity: this.state.tooltip.show ? 1.0 : 0.0,
              visibility: this.state.tooltip.show ? "visible" : "hidden",
            }}
          >
            <XRayTooltip
              data={this.state.tooltip}
              close={this.closeTooltip.bind(this)}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
